import React, { useEffect, useState } from 'react'
import { Input, message, Modal, Table } from 'antd'
import { useMessagewarnlistModel } from '../messagewarnlistModel'
import { IMessagewarnlistDetail, messagewarnlistService } from '../messagewarnlistService'
import YhTootip from '@/components/YhTootip'
import { messageStatusEnum } from '@/types/AppEnums'
import { momentFormat } from '@/utils/utils'
import { ColumnWidthOutlined, SettingOutlined } from '@ant-design/icons'
import { commonService } from '@/service/common'
import { YhTableSort } from '@/components/YhTableSort'

const sortKey = 'messagewarnMessagewarnlist'

export function DataTable() {
    const { dataSource, selectedRowKeys, pgCfg, loadData, setSelectedRowKeys, columnsSetVisible, setColumnsSetVisible, orders, handleRead } = useMessagewarnlistModel()
    useEffect(() => {
        loadData()
    }, [])

    const handleEnd = (record) => {
        let remark = ''
        Modal.confirm({
            title: '确定完成？',
            centered: true,
            closable: true,
            content: (
                <>
                    <Input
                        placeholder="请输入备注"
                        onChange={(e) => {
                            remark = e.target.value
                        }}
                    />
                </>
            ),
            onOk() {
                if (!remark) {
                    return message.error('请输入备注')
                }
                messagewarnlistService.end({ id: record.id, remark }).then((res) => {
                    if (res.retData) {
                        message.success('编辑成功！')
                    } else {
                        message.error('编辑失败')
                    }
                    loadData()
                })
            },
        })
    }

    const [columns, setColumns] = useState<any[]>([])
    //操作是否展示
    const [controls, setControls] = useState<boolean>(true)
    const getColumns = () => {
        commonService.userCustomizeConfigOne(sortKey).then((res) => {
            if (!res.retData) {
                setColumns([...getRegularColumns(), ...defaultColumns])
            } else {
                let newColumns: any[] = [...getRegularColumns()]
                let data = JSON.parse(res.retData.val)
                data.forEach((element) => {
                    if (element.isShow) {
                        newColumns.push({ ...defaultColumns.find((i) => i.dataIndex === element.key), sorter: element.isSort })
                    }
                })
                setColumns(newColumns)
            }
        })
    }

    const onSuccess = () => {
        setColumnsSetVisible(false)
        getColumns()
    }

    useEffect(() => {
        getColumns()
    }, [controls])

    const getRegularColumns = () => {
        return controls
            ? [
                {
                    title: (
                        <>
                            <span>
                                <SettingOutlined
                                    onClick={() => {
                                        setColumnsSetVisible(true)
                                    }}
                                />
                            </span>
                            <span>序号</span>
                        </>
                    ),
                    width: 80,
                    fixed: 'left',
                    align: 'center',
                    render: (t, r, i) => i + 1,
                },

                {
                    title: (
                        <>
                            <span>操作</span>
                            <span style={{ color: '#4165E3', cursor: 'pointer', float: 'right' }} onClick={() => setControls(false)}>
                                <ColumnWidthOutlined />
                            </span>
                        </>
                    ),
                    width: 160,
                    fixed: 'left',
                    dataIndex: 'status',
                    render: (text, record) => {
                        if (text === messageStatusEnum.MESSAGE_INIT) {
                            return (
                                <span
                                    style={{ color: 'blue', cursor: 'pointer' }}
                                    onClick={() => {
                                        handleRead(record)
                                    }}
                                >
                                    标为已读
                                </span>
                            )
                        } else if (text === messageStatusEnum.MESSAGE_READ) {
                            return (
                                <span
                                    style={{ color: 'blue', cursor: 'pointer' }}
                                    onClick={() => {
                                        handleEnd(record)
                                    }}
                                >
                                    完成
                                </span>
                            )
                        }
                    },
                },
            ]
            : [
                {
                    title: (
                        <>
                            <span>序号</span>
                            <span style={{ color: '#4165E3', cursor: 'pointer' }} onClick={() => setControls(true)}>
                                <ColumnWidthOutlined />
                            </span>
                        </>
                    ),
                    width: 80,
                    fixed: 'left',
                    align: 'center',
                    render: (t, r, i) => i + 1,
                },
            ]
    }

    const defaultColumns = [
        {
            title: '处理状态',
            width: 100,
            dataIndex: 'status',
            render: (text) => {
                if (text === messageStatusEnum.MESSAGE_INIT) {
                    return (
                        <span
                            style={{
                                display: 'inline-block',
                                width: '52px',
                                height: '22px',
                                background: "rgba(234,17,17,0.1)",
                                borderRadius: '4px',
                                fontSize: '12px',
                                color: '#EA1111',
                                lineHeight: '22px',
                                textAlign: 'center',
                            }}
                        >
                            未读
                        </span>
                    )
                } else if (text === messageStatusEnum.MESSAGE_READ) {
                    return (
                        <span
                            style={{
                                display: 'inline-block',
                                width: '52px',
                                height: '22px',
                                background: 'rgba(65, 101, 227,.1)',
                                borderRadius: '4px',
                                fontSize: '12px',
                                color: '#4165E3',
                                lineHeight: '22px',
                                textAlign: 'center',
                            }}
                        >
                            已读
                        </span>
                    )
                } else if (text === messageStatusEnum.MESSAGE_END) {
                    return (
                        <span
                            style={{
                                display: 'inline-block',
                                width: '52px',
                                height: '22px',
                                background: 'rgba(153, 153, 153,.1)',
                                borderRadius: '4px',
                                fontSize: '12px',
                                color: '#999999',
                                lineHeight: '22px',
                                textAlign: 'center',
                            }}
                        >
                            已处理
                        </span>
                    )
                }
            },
            isSet: true,
        },
        {
            title: '预警类型',
            width: 160,
            dataIndex: 'warningTypeName',
            isSet: true,
        },
        {
            title: '标题',
            width: 160,
            dataIndex: 'subject',
            isSet: true,
            render: (text) => <YhTootip text={text} style={{ width: '160px' }} />,
        },
        {
            title: '所属业务',
            width: 140,
            dataIndex: 'businessTypeName',
            isSet: true,
        },
        {
            title: '内容',
            width: 300,
            dataIndex: 'content',
            isSet: true,
        },
        {
            title: '短信接收人',
            width: 160,
            dataIndex: 'recipient',
            isSet: true,
        },
        {
            title: '已读人',
            width: 160,
            dataIndex: 'readPerson',
            isSet: true,
        },
        {
            title: '已读时间',
            width: 160,
            dataIndex: 'readTime',
            render: (text) => momentFormat(text),
            isSet: true,
        },
        {
            title: '完成人',
            width: 160,
            dataIndex: 'endPerson',
            isSet: true,
        },
        {
            title: '完成时间',
            width: 160,
            dataIndex: 'endTime',
            render: (text) => momentFormat(text),
            isSet: true,
        },
        {
            title: '推送时间',
            width: 160,
            dataIndex: 'createTime',
            render: (text) => momentFormat(text),
            isSet: true,
        },
        {
            title: '备注',
            width: 200,
            dataIndex: 'remark',
            isSet: true,
            render: (text) => <YhTootip text={text} style={{ width: '200px' }} />,
        },
    ]

    //点击行选高亮
    const onRow = (record: IMessagewarnlistDetail) => {
        let findObj = selectedRowKeys.find((item) => item.id === record.id)
        if (findObj) {
            let newSelectedRowKeys = selectedRowKeys.filter((item) => item.id !== record.id)
            setSelectedRowKeys(newSelectedRowKeys)
        } else {
            setSelectedRowKeys((origin) => [...origin, record])
        }
    }

    const onChange = (pagination, filters, sorter) => {
        if (Object.keys(sorter).length > 0) {
            orders.current = [{ column: sorter.field, asc: sorter.order === 'ascend' }]
            loadData()
        }
    }

    return (
        <>
            <Table
                rowKey={(record) => record.id}
                // rowSelection={{
                //     //全部选中时 (存row[])
                //     onSelectAll: (selected, selectedRows, changeRows) => {
                //         selected ? setSelectedRowKeys((origin) => [...origin, ...changeRows])
                //             : setSelectedRowKeys((origin) => {
                //                 let changeRowId = changeRows.map(item => item.id);
                //                 return origin.filter(item => changeRowId.indexOf(item.id) < 0)
                //             });
                //     },
                //     onSelect: (record, selected, selectedRows) => onRow(record),
                //     selectedRowKeys: selectedRowKeys.map(item => item.id)
                // }}
                onChange={onChange}
                columns={columns}
                dataSource={dataSource}
                pagination={{
                    ...pgCfg,
                    position: ['bottomRight'],
                    showTotal: () => `共${pgCfg.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    },
                    showSizeChanger: true,
                }}
                bordered
                onRow={(record) => ({
                    onClick: () => onRow(record),
                    onContextMenu: (e) => {
                        e.preventDefault()
                        setSelectedRowKeys([record])
                    },
                })}
                scroll={{ x: 'max-content', y: 'calc(100vh - 380px)' }}
            />
            <YhTableSort
                sortKey={sortKey}
                visible={columnsSetVisible}
                setVisible={setColumnsSetVisible}
                defaultColumns={defaultColumns}
                onSuccess={onSuccess}
            />
        </>
    )
}
